import { post, get, patch, deleteRequest } from "./restApi";

export const getReturnDevices = (payload) => {
  return patch("return-device/get-list", { ...payload });
};
export const deleteReturnDevice = (payload) => {
  return deleteRequest(`return-device/delete-return-device-by-id`, {
    ...payload,
  });
};
export const createReturnDevice = (payload) => {
  return post("return-device/create", payload);
};
export const getReturnDeviceById = (id) => {
  return get(`return-device/get-by-id/${id}`);
};
export const updateReturnDeviceById = (id, payload) => {
  return patch(`return-device/update-by-id/${id}`, {
    ...payload,
  });
};
export const exportTheReturnDeviceFileWord = (id, payload) => {
  return get(`return-device/export-file-word/${id}`, {
    ...payload,
  });
};
export const approveReturnDevice = (id, payload) => {
  return patch(`return-device/approve-return-device-by-id/${id}`, {
    ...payload,
  });
};
export const confirmTheReturnDeviceNew = (id, payload) => {
  return patch(`return-device/confirm-new/${id}`, { ...payload });
};
export const approveTheReturnDeviceAssetMaintenance = (id, payload) => {
  return patch(
    `return-device/approve-return-device-asset-maintenance-by-id/${id}`,
    {
      ...payload,
    },
  );
};
export const rejectTheReturnDeviceAssetMaintenance = (id, payload) => {
  return patch(
    `return-device/reject-return-device-asset-maintenance-by-id/${id}`,
    {
      ...payload,
    },
  );
};
export const createReturnDeviceAttachment = (payload) => {
  return post(`return-device/create-return-device-attachment`, { ...payload });
};
export const deleteReturnDeviceAttachment = (payload) => {
  return deleteRequest(`return-device/delete-return-device-attachment`, {
    ...payload,
  });
};
export const getReturnDeviceAttachmentByReturnDeviceId = (id, payload) => {
  return get(
    `return-device/get-return-device-attachment-by-return-device-id/${id}`,
    { ...payload },
  );
};
